import React from 'react';
import { createContainer } from 'unstated-next';

import { workshopApi } from '@/integrations/api';

import { useRemoteData } from '@/hooks/useRemoteData';
import { useSubscription } from '@/hooks/useSubscription';
import { useWorkshopId } from '@/hooks/useWorkshopId';

export const useWorkshop = () => {
  const workshopId = useWorkshopId();

  const workshop = useRemoteData(
    { key: 'getWorkshop', workshopId, skip: !workshopId },
    ({ workshopId }) => workshopApi.getWorkshopByID(workshopId!).then((r) => r.data),
    { revalidateOnFocus: false }
  );

  const subscription = useSubscription({ revalidateOnFocus: false, shouldRetryOnError: false });

  const loading = workshop.isLoading || subscription.isLoading;

  return React.useMemo(
    () => ({
      loading,
      workshop: workshop.data,
      subscription: subscription.data,
      reload: () => Promise.all([workshop.mutate(), subscription.mutate()])
    }),
    [loading, workshop, subscription]
  );
};

export const Workshop = createContainer(useWorkshop);
